'use strict';

function WealthTabs() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  // The default page priority is at 2000.
  // the lower the value, the higher the priority
  // we want this top tray to load before the page
  this.priority = 800;

  this.init = function () {
    this.tabItems = [{
      title: 'Overview',
      url: '/member/dashboard/wealth',
      ariaControls: 'Overview',
      analyticsId: 'MogoWealth-Navigation-Overview-Navigation-Component'
    }];

    $('#WealthTabs').mogo().create('TabsNavigation', {
      tabs: this.tabItems
    });
  };

  this.initAllReady = function () {};

  this.destroy = function () {};
}